module.exports = __webpack_public_path__ + "static/media/integrations.e913ce71.svg";